const Userf = () => {
  return (
    <div className="user-card">
      <h2>name:saqlain</h2>
      <h3>location:bbsr</h3>
      <h4>contact:-mdsaq07</h4>
    </div>
  )
};
export default Userf;
